module.exports = __webpack_public_path__ + "img/loader-white.f92f9fee.webp";